export const HOMEPAGE_CONSTANT = {
  NOTIFICATION_ERROR_TITLE: 'Alert!',
  NOTIFICATION_ERROR_CONTENT_EXP_TOKEN: 'Session Timeout',
  NOTIFICATION_ERROR_CONTENT_DETAIL_EXP_TOKEN: 'Please re-login',
}